//Components/Leagues.jsx
import React, { useState, useEffect  } from 'react';
import axios from "axios";
import { IoHome } from "react-icons/io5";
import { FiEdit, } from "react-icons/fi"; // אייקוני עריכה והוספה
import { SlBookOpen } from "react-icons/sl";
import { FaHouse } from "react-icons/fa6";

import { useNavigate } from "react-router-dom";
import './Leagues.css';
import MatchSchedule from '../MatchesSchedule/MatchesSchedule';
import RankingTable from "../RankingTable/RankingTable";
import { useAuth } from "../../Context/AuthContext";
import TeamForm from '../TeamForm/TeamForm';

const API = process.env.REACT_APP_API;

function Leagues() {
  const { user } = useAuth(); 
  const navigate = useNavigate();

  const [leagues, setLeagues] = useState([]);
  const [selectedLeague, setSelectedLeague] = useState(null);
  const [selectedView, setSelectedView] = useState(null); // null | 'ranking' | 'structure'
  const [stages, setStages] = useState([]);
  const [selectedStage, setSelectedStage] = useState(null); // שלב נבחר
  const [files, setFiles] = useState([]);
  const [loadingFiles, setLoadingFiles] = useState(true);

    // NEW: state for opening the inner "add/edit team" overlay
  const [addingTeamOverlay, setAddingTeamOverlay] = useState(false);
  const [editingTeamForForm, setEditingTeamForForm] = useState(null);

  useEffect(() => {
  axios
    .get("/api/regulations")
    .then((res) => setFiles(res.data))
    .catch((err) => console.error("שגיאה בטעינת קבצים:", err))
    .finally(() => setLoadingFiles(false));
}, []);

  // טעינת ליגות
  useEffect(() => {
    const fetchLeagues = async () => {
      try {
        const res = await axios.get(`${API}/api/leagues`);
        setLeagues(res.data);
      } catch (err) {
          console.error("שגיאה בטעינת ליגות:", err);
      }
    };
    fetchLeagues();
  }, []);

  // טעינת שלבים לליגה שנבחרה
  // const fetchStages = async (leagueCode) => {
  //   try {
  //     // setLoading(true);
  //     const res = await axios.get(`${API}/api/leagues/${leagueCode}/stages`);
  //     setStages(res.data);
  //   } catch (err) {
  //       console.error("שגיאה בטעינת שלבים:", err);
  //   }
  // };

  const handleLeagueClick = async (league) => {
    setSelectedLeague(league);
    setSelectedView("matches"); // איפוס תצוגה
    try {
    // שולפים שלבים
    const res = await axios.get(`${API}/api/leagues/${league.code}/stages`);
    const stagesData = res.data;
    setStages(stagesData);

    // 🟢 אם יש רק שלב אחד — בחר אותו אוטומטית
    if (stagesData.length === 1) {
      setSelectedStage(stagesData[0]);
    }
    // 🟢 אם יש יותר משלבים והוגדרה ברירת מחדל
    else if (league.defaultStageId) {
      const defaultStage = stagesData.find(s => s._id === league.defaultStageId);
      if (defaultStage) {
        setSelectedStage(defaultStage);
      } else {
        setSelectedStage(null); // אם ברירת מחדל לא קיימת
      }
    } 
    // 🟡 אחרת — לא בוחר שלב עד לחיצה ידנית
    else {
      setSelectedStage(null);
    }

  } catch (err) {
    console.error("שגיאה בטעינת שלבים:", err);
    setStages([]);
    setSelectedStage(null);
  }
  };

  const handleStageClick = (stage) => {
    setSelectedStage(stage);
    setSelectedView("matches");
  };

  // callback passed to TeamForm to close overlay and (optionally) refresh things
  const onTeamFormSaved = () => {
    setAddingTeamOverlay(false);
    setEditingTeamForForm(null);
  };

return (
  <div className="container">
    {/* אייקון הבית בפינה שמאלית עליונה */}
    <div className="home-icon" onClick={() => navigate("/")}>
      <IoHome title="עמוד הבית" size={30} />
    </div>
    
    <div className='header-items'>
    <h3 className="subtitle">הליגות שלנו</h3>
    <div className="pdf-container">
        {!loadingFiles && files.length === 0 ? (
          <p className="no-files-message">אין קבצים להצגה</p>
        ) : (
        files.map(file => (
          <div key={file._id}>
            <button key={file._id}
              onClick={() => window.open(file.filePath, "_blank")}
              className="pdf-btn"
            >
              {file.title}
              {user?.isAdmin && (
                <FiEdit
                  className="edit-icon"
                  size={18}
                  title={"עריכה"}
                  onClick={() => navigate(`/regulations/edit/${file._id}`)}
                />
              )}
            </button>
          </div>
          ))
        )}
      </div>
    </div>

    {/* כפתור הוספת ליגה למנהל */}
    {user?.isAdmin && (
      <div className="add-league-button" onClick={() => navigate("/leagues/new")}>
        ➕ הוסף ליגה חדשה
      </div>
    )}

    <div className='leagues-header-row'>
      {/* כפתורי ליגות */}
      <div className="leagues-grid">
        {leagues.map((lg) => (
          <div key={lg._id} className="league-wrapper">
            <button
              key={lg._id}
              onClick={() => handleLeagueClick(lg)}
              className={`league-card ${selectedLeague?.code === lg.code ? 'active' : ''}`}
              >
              {lg.name}
            {/* אייקון עריכה למנהל */}
            {user?.isAdmin && (
              <FiEdit 
                className="edit-league-icon" 
                size={18} 
                title={`עריכת ליגה`} 
                onClick={(e) => { e.stopPropagation(); navigate(`/leagues/edit/${lg._id}`); }}
              />
            )}
          </button>
          </div>
        ))}
      </div>
      
      <div className='icons'>
        <button 
          className="structure-overlay-icon" 
          onClick={() => navigate("/teams")} title='מבנה הליגות והקבוצות'
          size={30}
        >
          פרטים
          <SlBookOpen />
        </button>

        <button 
          className="halls-overlay-icon" 
          onClick={() => navigate("/halls")} title='אולמות'
          size={30}
        >
          אולמות
          <FaHouse />
        </button>
      </div>
       
    </div>

    {/* אם יש שלבים – הצג כפתורים */}
    {stages.length > 0 ? (
      <div className="stage-buttons">
        {stages.map(stage => (
          <button
            key={stage._id}
            onClick={() => handleStageClick(stage)}
            className={`stage-btn ${selectedStage?._id === stage._id ? "active" : ""}`}
          >
            {stage.name}
          </button>
        ))}
      </div>
    ) : (
    // אם אין שלבים – הצג הודעה
      selectedLeague && (
        <p className="no-stages-message">
          {`אין שלבים לליגת "${selectedLeague.name}" להצגה`}
        </p>
      )
  )}

  {/* כותרת בהתאם לתצוגה */}
  <h4>
    {selectedLeague ? " " : 'המשחקים הקרובים'}
  </h4>


  {/* כפתורים נוספים להצגת טבלה / מבנה */}
  {selectedLeague && selectedStage && (
    <div className="league-view-buttons">
      <button onClick={() => {
        if (selectedView === 'ranking') {
          // חזרה לרשימת המשחקים של אותו שלב
          setSelectedView('matches');
        } else {
          // הצגת טבלת דירוג
          setSelectedView('ranking');
        }
      }}
      className={selectedView === 'ranking' ? 'active' : ''}>
        {selectedView === 'ranking' ? 'חזרה לרשימת המשחקים' : 'טבלת דירוג'}
      </button>
    </div>
  )}

  {/* הצגת תצוגה לפי בחירה */}
  {/* משחקים */}
  {selectedLeague && (selectedView === 'matches' || selectedView === null) ? (
    <MatchSchedule filterLeague={selectedLeague} filterStage={selectedStage} />
  ) : !selectedLeague && (selectedView === null) ? (
    <MatchSchedule filterLeague={null} />
  ): null}

  {/* טבלת דירוג */}
  {selectedLeague && selectedStage && selectedView === "ranking" &&  (
    <RankingTable league={selectedLeague} stage={selectedStage}/>
  )}

  {/* === OVERLAY נפרד ל-Add/Edit Team שמופיע מעל ה-overlay של הליגות === */}
  {addingTeamOverlay && (
    <div className="team-overlay">
      <div className="overlay-header" style={{ width: '90%' }}>
        <h3 style={{ color: 'white' }}>{editingTeamForForm ? 'עריכת קבוצה' : 'הוספת קבוצה'}</h3>
        <button className="close-btn" onClick={() => { setAddingTeamOverlay(false); setEditingTeamForForm(null); }}>✖</button>
      </div>

      <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '1rem' }}>
        <TeamForm
          editingTeam={editingTeamForForm}
          onSaved={onTeamFormSaved}
          onCancel={() => { setAddingTeamOverlay(false); setEditingTeamForForm(null); }}
        />
      </div>
    </div>
  )}
    
  </div>
  );
}

export default Leagues;
